export default {"src":"/_next/static/media/docxster-logo-with-name.c9bf93a9.svg","height":117,"width":306,"blurWidth":0,"blurHeight":0};